/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This model represents a paginated response from Spring Data
 */

import { ScenarioLogDto } from './scenarioLogDto';

export interface PageScenarioLogDto {
    content?: Array<ScenarioLogDto>;
    totalElements?: number;
    totalPages?: number;
    number?: number;
    size?: number;
    first?: boolean;
    last?: boolean;
    empty?: boolean;
}
